module.exports = __webpack_public_path__ + "img/c-en-21.e4c83408.png";